import { render, staticRenderFns } from "./my_informal_wage_record.vue?vue&type=template&id=358c0a56&scoped=true"
import script from "./my_informal_wage_record.vue?vue&type=script&%3Aroute=%7Bpath%3A%20'%2Fteam%2Fmy_informal_wage_record%2F%3Aid'%2CnoChkout%3A%20true%7D&lang=js"
export * from "./my_informal_wage_record.vue?vue&type=script&%3Aroute=%7Bpath%3A%20'%2Fteam%2Fmy_informal_wage_record%2F%3Aid'%2CnoChkout%3A%20true%7D&lang=js"
import style0 from "./my_informal_wage_record.vue?vue&type=style&index=0&id=358c0a56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358c0a56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
